module.exports = __webpack_public_path__ + "static/media/CSS.8e252e3e.png";